import ApiClient from './ApiClient';

class CrmEventsAPI extends ApiClient {
  constructor() {
    super('crm_events', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { crm_event: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { crm_event: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  upcoming() {
    return axios.get(`${this.url}/upcoming`);
  }

  notificationsDue(params = {}) {
    return axios.get(`${this.url}/notifications_due`, { params });
  }

  getByDateRange(startDate, endDate) {
    return axios.get(this.url, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  getByContact(contactId, params = {}) {
    return axios.get(this.url, {
      params: { contact_id: contactId, ...params },
    });
  }
}

export default new CrmEventsAPI();
